import React from "react";
import { Icon } from "../Icon";
import { Popover, PopoverContent, PopoverTrigger } from "../Popover";

interface InfoButtonProps {
  examples?: string[];
  description?: string;
  ariaLabel?: string;
  className?: string;
}

const InfoButton: React.FC<InfoButtonProps> = ({
  examples = [],
  description,
  ariaLabel = "Field help",
  className = "",
}) => {
  if (!examples.length && !description) {
    return null;
  }

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label={ariaLabel}
          className={`text-muted-foreground hover:text-foreground focus-visible:ring-ring data-[state=open]:text-foreground ms-1 inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full transition-colors focus-visible:ring-2 focus-visible:outline-none motion-reduce:transition-none ${className}`}
        >
          <Icon name="HelpCircle" className="h-3.5 w-3.5" />
        </button>
      </PopoverTrigger>
      <PopoverContent
        side="bottom"
        align="start"
        sideOffset={8}
        className="w-64 p-3 text-xs"
        onOpenAutoFocus={(event) => event.preventDefault()}
      >
        {description ? <p className="leading-5">{description}</p> : null}
        {examples.length > 0 ? (
          <p
            className={`text-muted-foreground leading-5 ${description ? "mt-1.5" : ""}`}
          >
            {examples.join(" · ")}
          </p>
        ) : null}
      </PopoverContent>
    </Popover>
  );
};

export { InfoButton };
